export const DEFAULT_LABEL_WIDTH = 136

export const FILE_UPDATE_NAME_MAX_WIDTH = 188

export const FILE_UPLOAD_BUTTON_WIDTH = 120
